module.exports = __webpack_public_path__ + "img/kucing.53045a5b.svg";